import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Avatar,
  Box,
  InputLabel,
  Select,
  FormControl,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { GlobalStyles } from "@mui/system";
import { IconButton } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../AuthProvider";

import { Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import PresentToAllIcon from "@mui/icons-material/PresentToAll";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import { useLocation } from "react-router-dom";

const baseUrl = process.env.REACT_APP_API_BASE_URL;
function OrgDashUnPaidTutionFee() {
  const { oId, board ,pId,userId,role} = useAuth();
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();
  const [selectedBus, setSelectedBus] = useState("");
  const [busData, setBusData] = useState([]);
  const [showTransactions, setShowTransactions] = useState(false);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedadmissionNo, setselectedAdmissionNo] = useState(null);

  const [dialogTableloading, setDialogTableloading] = useState(true);
  const [dialogTableData, setDialogTableData] = useState(null);

  // const [selectedClass, setSelectedClass] = useState("Class-I");
  // const [selectedSection, setSelectedSection] = useState("Section-A"); // Default to SECTION-A

  // const [classSectionData, setClassSectionData] = useState([]);
  // const [classOptions, setClassOptions] = useState([]);
  // const [sectionOptions, setSectionOptions] = useState([]);
   const [sscClassOptions, setSscClassOptions] = useState([]);
  const [sscSectionOptions, setSscSectionOptions] = useState([]);
  // const [sscSelectedClass, setSscSelectedClass] = useState("");
  // const [sscSelectedSection, setSscSelectedSection] = useState("");

  const [sscSelectedClass, setSscSelectedClass] = useState("");
// const [sscSelectedSection, setSscSelectedSection] = useState("");
const [sscSelectedSection, setSscSelectedSection] = useState("");
const [interSelectedClass, setInterSelectedClass] = useState("");
const [interSelectedSection, setInterSelectedSection] = useState("");
 
  // INTERMEDIATE states
  const [interSectionOptions, setInterSectionOptions] = useState([]);
  // const [interSelectedClass, setInterSelectedClass] = useState("");
  // const [interSelectedSection, setInterSelectedSection] = useState("");
  const [courseOptions, setCourseOptions] = useState([]);
  const [selectedCourseType, setSelectedCourseType] = useState("");
 


  const [mode, setMode] = useState("scrolling"); // "scrolling" or "classSection"
  console.log("selected mode :"+mode);
  const [sscClassSectionMap, setSscClassSectionMap] = useState({});
  const [hasFetchedOnce, setHasFetchedOnce] = useState(false); // new flag



  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const isExportMenuOpen = Boolean(exportAnchorEl);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const dateRangeFromQuery = queryParams.get("dateRange");

  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };

  const handleExportClose = () => {
    setExportAnchorEl(null);
  };
  const handleClose = () => {
    setExportAnchorEl(null);
  };

  const handleViewClick = (row) => {
    setSelectedRowData(row); // Set the selected row's data
    setselectedAdmissionNo(row.admissionNumber);
    setDialogOpen(true); // Open the dialog
  };

  const handleCloseDialog = () => {
    setDialogOpen(false); // Close the dialog
  };






  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState("");
  const isPrincipal = role?.startsWith("PRINCIPAL") || false;
  const UserId = userId || selectedUsers;
  console.log("Selected User:",UserId);




//fetch table scrolling data
  useEffect(() => {
    fetchGetAllTableData();
  }, [oId]);


const fetchGetAllTableData = async () => {
 
  setLoading(true);
  setHasFetchedOnce(false);
  try {
    let endpoint = "";
    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${String(
      today.getMonth() + 1
    ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

    switch (
      dateRangeFromQuery // ✅ Changed to 'dateRange'
    ) {
      case "today":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllStudentsTodayFeeTransaction/${formattedDate}/tution_fee/${oId}`;
        break;              
      case "yesterday":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllStudentsYesterDayFeeTransaction/${formattedDate}/tution_fee/${oId}`;
        break;
      case "lastWeek":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllStudentsLastWeekFeeTransaction/${formattedDate}/tution_fee/${oId}`;
        break;
      case "CurrentMonth":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllStudentsThisMonthFeeTransaction/${formattedDate}/tution_fee/${oId}`;
        break;
      case "last6Months":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllStudentsLastSixMonthsFeeTransaction/${formattedDate}/tution_fee/${oId}`;
        break;
     
        case "currentAcademicYear":
          endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllStudentsCurrentAcademicYearFeeTransactionUnPaidOverAllList/${oId}?rolePayment=tution_fee`;
          break;              
      default:
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllStudentsCurrentAcademicYearFeeTransactionUnPaidOverAllList/${oId}?rolePayment=tution_fee`;
          break;
    }

    const response = await fetch(endpoint);
    if (!response.ok) throw new Error("Failed to fetch data");

    const data = await response.json();
    const filtered = data.filter(item => item.feeDue > 0);
    setFilteredData(filtered);
  } catch (error) {
    console.error("Error fetching tuition fee amounts:", error);
    setFilteredData([]); // Ensure table does not break on error
  }
  finally {
    setLoading(false);
    setHasFetchedOnce(true); // mark as fetched
  }
};





// -------------------------------------------
//           For SSC functions
// -------------------------------------------

// ---- Fetch Class + Sections for SSC (School) ----
// const fetchClassRegistrationData = async () => {
//   try {
//     const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`);
//     const data = await response.json();

//     if (response.ok && Array.isArray(data)) {
//       // Group by class and merge section strings into unique values
//       const classSectionMap = {};

//       data.forEach(item => {
//         const className = item.classRegistration;
//         const sectionList = item.sections.split(",").map(s => s.trim());

//         if (!classSectionMap[className]) {
//           classSectionMap[className] = new Set();
//         }

//         sectionList.forEach(section => classSectionMap[className].add(section));
//       });

//       const classes = Object.keys(classSectionMap);
//       setSscClassOptions(classes); // Class dropdown options
//       setSscClassSectionMap(classSectionMap); // Save for section filtering later

//       // No default selection
//       setSscSelectedClass("");
//       setSscSelectedSection("");
//       setSscSectionOptions([]);
//     }
//   } catch (error) {
//     console.error("Error fetching SSC data:", error);
//   }
// };





// ---- Fetch Table Data for SSC ----
const fetchClassSectionTableData = async () => {
  if (!sscSelectedClass || !sscSelectedSection) {
    setFilteredData([]);
    // setOriginalData([]);
    setLoading(false);
    return;
  }
  setLoading(true);
  try {
    let endpoint = "";
    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${String(
      today.getMonth() + 1
    ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

    switch (
      dateRangeFromQuery // ✅ Changed to 'dateRange'
    ) {
      case "today":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getTodayTransaction/${formattedDate}/tution_fee/${oId}/${UserId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}`;
        break;
      case "yesterday":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getYesterDayTransaction/${formattedDate}/tution_fee/${oId}/${UserId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}`;
        break;
      case "lastWeek":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getLastWeekTransaction/${formattedDate}/tution_fee/${oId}/${UserId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}`;
        break;
      case "CurrentMonth":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getThisMonthTransaction/${formattedDate}/tution_fee/${oId}/${UserId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}`;
        break;
      case "last6Months":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getLastSixMonthsTransaction/${formattedDate}/tution_fee/${oId}/${UserId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}`;
        break;
         case "currentAcademicYear":
          endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getCurrentAcademicYearTransactionUnPaid/${oId}/${UserId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}&rolePayment=tution_fee`;
          break;                

      default:
       endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getCurrentAcademicYearTransactionUnPaid/${oId}/${UserId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}&rolePayment=tution_fee`;
          break;  
    }

    const response = await fetch(endpoint);
    if (!response.ok) throw new Error("Failed to fetch data");

    const data = await response.json();
    const filtered = data.filter(item => item.feeDue > 0);

    if(filtered.length>0){
      setFilteredData(filtered)
    }else{
      setFilteredData([]);
    }
    // setFilteredData(data);
  } catch (error) {
    console.error("Error fetching tuition fee amounts:", error);
    setFilteredData([]); // Ensure table does not break on error
  }
  finally {
    setLoading(false);
  }
};




// -------------------------------------------
//           For Intermediate functions
// -------------------------------------------

// ---- Fetch Courses for INTERMEDIATE ----
const fetchCourseData = async () => {
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllcourses/${pId}`);
    const data = await response.json();
    if (response.ok && Array.isArray(data)) {
      setCourseOptions(data);
      // if (!selectedCourseType) {
      //   setSelectedCourseType("");
      // }
    } else {
      setCourseOptions([]);
    }
  } catch (error) {
    console.error("Error fetching course data:", error);
    setCourseOptions([]);
  }
};

// ---- Fetch Sections for INTERMEDIATE ----

const fetchSectionsData = async () => {
  if (!interSelectedClass || !selectedCourseType) {
    setInterSectionOptions([]);
    setInterSelectedSection("");
    return;
  }

  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/getAllClass-registrations/${interSelectedClass}/${selectedCourseType}/${pId}`
    );
    const data = await response.json();

    if (response.ok && Array.isArray(data) && data.length > 0) {
      const sectionsString = data[0].sections || "";
      const sections = sectionsString
        .split(",")
        .map((section) => section.trim());

      setInterSectionOptions(sections);
      setInterSelectedSection(sections[0] || "");
    } else {
      setInterSectionOptions([]);
      setInterSelectedSection("");
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE section data:", error);
    setInterSectionOptions([]);
    setInterSelectedSection("");
  }
};




//`${baseUrl}/api/feePayment/getAllfeePayments/${oId}?course=${selectedCourseType}&romanNumberClass=${interSelectedClass}&sections=${interSelectedSection}&rolePayment=tution_fee`

// ---- Fetch Table Data for INTERMEDIATE ----
const fetchCourseClassSectionTableData = async () => {
  if (!selectedCourseType || !interSelectedClass || !interSelectedSection) {
    setFilteredData([]);
    // setOriginalData([]);
    setLoading(false);
    return;
  }
  setLoading(true);
  try {
    let endpoint = "";
    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${String(
      today.getMonth() + 1
    ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

    switch (
      dateRangeFromQuery // ✅ Changed to 'dateRange'
    ) {
      case "today":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getTodayTransaction/${formattedDate}/tution_fee/${oId}/${UserId}?course=${selectedCourseType}&romanNumberClass=${interSelectedClass}&sections=${interSelectedSection}`;
        break;
      case "yesterday":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getYesterDayTransaction/${formattedDate}/tution_fee/${oId}/${UserId}?course=${selectedCourseType}&romanNumberClass=${interSelectedClass}&sections=${interSelectedSection}`;
        break;
      case "lastWeek":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getLastWeekTransaction/${formattedDate}/tution_fee/${oId}/${UserId}?course=${selectedCourseType}&romanNumberClass=${interSelectedClass}&sections=${interSelectedSection}`;
        break;
      case "CurrentMonth":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getThisMonthTransaction/${formattedDate}/tution_fee/${oId}/${UserId}?course=${selectedCourseType}&romanNumberClass=${interSelectedClass}&sections=${interSelectedSection}`;
        break;
      case "last6Months":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getLastSixMonthsTransaction/${formattedDate}/tution_fee/${oId}/${UserId}?course=${selectedCourseType}&romanNumberClass=${interSelectedClass}&sections=${interSelectedSection}`;
        break;
      case "last365Days":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getLastListPaidInYearTransaction/${formattedDate}/tution_fee/${oId}/${UserId}?course=${selectedCourseType}&romanNumberClass=${interSelectedClass}&sections=${interSelectedSection}`;
        break;
        case "currentAcademicYear":
          // endpoint = `${baseUrl}/api/admissionFeeDashBoard/getCurrentAcademicYearTransaction/${formattedDate}/tution_fee/${oId}?course=${selectedCourseType}&romanNumberClass=${interSelectedClass}&sections=${interSelectedSection}`;
          endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getCurrentAcademicYearTransactionUnPaid/${oId}/${UserId}?course=${selectedCourseType}&romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}&rolePayment=tution_fee`;
          break;
      default:
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getCurrentAcademicYearTransactionUnPaid/${oId}/${UserId}?course=${selectedCourseType}&romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}&rolePayment=tution_fee`;
          break;
    }

    const response = await fetch(endpoint);
    if (!response.ok) throw new Error("Failed to fetch data");

    const data = await response.json();
    const filtered = data.filter(item => item.feeDue > 0);

    if(filtered.length>0){
      setFilteredData(filtered)
    }else{
      setFilteredData([]);
    }
    // setFilteredData(data);
  } catch (error) {
    console.error("Error fetching tuition fee amounts:", error);
    setFilteredData([]); // Ensure table does not break on error
  }
   finally {
    setLoading(false);
  }
};




// useEffect(() => {
//   if (board === "INTERMEDIATE") {
//     fetchSectionsData();
//   } else if (board === "SSC") {
//     fetchClassRegistrationData();
//   }
// }, [board, interSelectedClass, selectedCourseType, oId]);

// SSC: When selected class changes, update its sections
// useEffect(() => {
//   const updateSectionOptions = async () => {
//     try {
//       const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}`);
//       const data = await response.json();
//       if (response.ok && Array.isArray(data)) {
//         const selectedClassData = data.find(item => item.classRegistration === sscSelectedClass);
//         if (selectedClassData) {
//           const sections = selectedClassData.sections.split(",");
//           setSscSectionOptions(sections);
//           setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0]);
//         } else {
//           setSscSectionOptions([]);
//           setSscSelectedSection("");
//         }
//       }
//     } catch (error) {
//       console.error("Error updating SSC sections:", error);
//     }
//   };

//   if (board === "SSC" && sscSelectedClass) {
//     updateSectionOptions();
//   }
// }, [sscSelectedClass, board, oId]);

// INTERMEDIATE: When class or course type changes, update sections
useEffect(() => {
  const updateIntermediateSections = async () => {
    if (board === "INTERMEDIATE" && interSelectedClass && selectedCourseType) {
      await fetchSectionsData();
    }
  };
  updateIntermediateSections();
}, [interSelectedClass, selectedCourseType, board]);


// Fetch course options if board is INTERMEDIATE
useEffect(() => {
  if (board === "INTERMEDIATE") {
    fetchCourseData();
  }
}, [board, oId]);

// Fetch Table Data whenever filters change
// useEffect(() => {
//   if (board === "SSC") {
//     if (!sscSelectedClass || !sscSelectedSection) {
//       setFilteredData([]);
//       setLoading(false); // ✅ stop loading even if API not called
//       return;
//     }
//     fetchClassSectionTableData(); // Modify inside function to use sscSelectedClass and sscSelectedSection
//   } else if (board === "INTERMEDIATE") {
//     if (!interSelectedClass || !interSelectedSection || !selectedCourseType) {
//       setFilteredData([]);
//       setLoading(false); // ✅ same here
//       return;
//     }
//     fetchCourseClassSectionTableData(); // Modify inside function to use interSelectedClass and interSelectedSection
//   }
// }, [board, sscSelectedClass, sscSelectedSection, interSelectedClass, interSelectedSection, selectedCourseType,dateRangeFromQuery]);

useEffect(() => {
  const fetchData = () => {
    if (board === "SSC") {
      if (sscSelectedClass && sscSelectedSection && mode === "classSection") {
        fetchClassSectionTableData();
      } else {
        setFilteredData([]);
        setLoading(false);
      }
    } else if (board === "INTERMEDIATE") {
      if (selectedCourseType && interSelectedClass && interSelectedSection && mode === "classSection") {
        fetchCourseClassSectionTableData();
      } else {
        setFilteredData([]);
        setLoading(false);
      }
    }
  };

  fetchData();
}, [board, sscSelectedClass, sscSelectedSection, selectedCourseType, interSelectedClass, interSelectedSection, mode]);








  // Dialog Transactions api
 
 
 
 
 
  useEffect(() => {
    const fetchDialogTableData = async () => {
      if (!selectedadmissionNo) return; // Prevent API call if no admission number is selected

      setDialogTableloading(true);
      try {
        const response = await fetch(
          `${baseUrl}/api/transaction/getAllTransaction/${selectedadmissionNo}/${oId}/tution_fee`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();
        console.log("Fetched Data:", data);
        setDialogTableData(data || []); // Ensure it's always an array
      } catch (error) {
        console.error("Error fetching Bus Numbers:", error);
        setDialogTableData([]); // Ensure state remains consistent
      } finally {
        setDialogTableloading(false); // Set loading to false after fetching
      }
    };

    fetchDialogTableData();
  }, [selectedadmissionNo, oId]); // Re-fetch when `selectedadmissionNo` or `oId` changes


  // Filter data based on searchQuery
  const filteredResults = filteredData.filter((item) => {
    const studentSurname = item.surName ? item.surName.toLowerCase() : "";
    const studentFirstName = item.firstName ? item.firstName.toLowerCase() : "";
    const studentLastName = item.lastName ? item.lastName.toLowerCase() : "";
    const fullName =
      `${studentSurname} ${studentFirstName} ${studentLastName}`.trim(); // Combine first and last names
    const admissionNumber = item.customAdmissionNumber
      ? item.customAdmissionNumber.toString()
      : ""; // Ensure it's a string

    return (
      fullName.includes(searchQuery.toLowerCase()) || // Search in full name
      admissionNumber.includes(searchQuery) // Search in admission number
    );
  });

  // Export to Excel
  const exportToExcel = () => {
    const isIntermediate = board === "INTERMEDIATE";
    const dynamicKey = isIntermediate ? "Year" : "Class";

    const filteredData = filteredResults.map(
      ({
        customAdmissionNumber,
        course,
        romanNumberClass,
        sections,
        firstName,
        lastName,
        gender,
        fathersName,
        primaryContact,
        grandTotal,
        feeDue,
      }) => ({
        AdmissionNumber: customAdmissionNumber,
        ...(isIntermediate ? { Course: course } : {}),
      [dynamicKey]: romanNumberClass,
        Section: sections,
        StudentName: `${firstName} ${lastName}`,
        Gender: gender,
        FatherName: fathersName,
        Phone: primaryContact,
        TotalFee: grandTotal,
        // PaidAmount: totalPaid,
        DueAmount: feeDue,
      })
    );

    const workbook = new ExcelJS.Workbook();
    // const worksheet = workbook.addWorksheet(
    //   board === "INTERMEDIATE"
    //   ? `${interSelectedClass}-${interSelectedSection}_UnPaidSchoolFeeList`
    //   : `${sscSelectedClass}-${sscSelectedSection}_UnPaidSchoolFeeList`
    // );

     const worksheet = workbook.addWorksheet(
  (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection)
    ? `${interSelectedClass}-${interSelectedSection}_UnPaidSchoolFeeList`
    : (board === "SSC" && sscSelectedClass && sscSelectedSection)
    ? `${sscSelectedClass}-${sscSelectedSection}_UnPaidSchoolFeeList`
    : "UnPaidSchoolFeeList"
);

    // Add headers
    worksheet.columns = [
      { header: "Admission No", key: "AdmissionNumber", width: 15 },
      ...(board === "INTERMEDIATE"
        ? [{ header: "Course", key: "Course", width: 15 }]
        : []),
      { header: isIntermediate ? "Year" : "Class", key: dynamicKey, width: 15 },
      { header: "Section", key: "Section", width: 10 },
      { header: "Student Name", key: "StudentName", width: 25 },
      { header: "Gender", key: "Gender", width: 10 },
      { header: "Father Name", key: "FatherName", width: 20 },
      { header: "Phone", key: "Phone", width: 15 },
      { header: "Total Fee", key: "TotalFee", width: 15 },
      // { header: "Paid Amount", key: "PaidAmount", width: 15 },
      { header: "Due Amount", key: "DueAmount", width: 15 },
    ];

    filteredData.forEach((data) => {
      const row = worksheet.addRow(data);
      // const paidCell = row.getCell("PaidAmount");
      const dueCell = row.getCell("DueAmount");

      // Apply green text color for Paid Amount
      // paidCell.font = { color: { argb: "008000" }, bold: true }; // Green & Bold

      // Apply red text color for Due Amount
      if (data.DueAmount > 0) {
        dueCell.font = { color: { argb: "FF0000" }, bold: true }; // Red & Bold
      }
    });

    // Style headers
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "87CEEB" }, // Light Blue Header
      };
    });

    // Write and download file
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);

      // link.download = board === "INTERMEDIATE"
      // ? `${interSelectedClass}-${interSelectedSection}_PaidSchoolFeeList.xlsx`
      // : `${sscSelectedClass}-${sscSelectedSection}_PaidSchoolFeeList.xlsx`;

       link.download =
  (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection)
    ? `${interSelectedClass}-${interSelectedSection}_UnPaidSchoolFeeList.xlsx`
    : (board === "SSC" && sscSelectedClass && sscSelectedSection)
    ? `${sscSelectedClass}-${sscSelectedSection}_UnPaidSchoolFeeList.xlsx`
    : "UnPaidSchoolFeeList.xlsx";


      link.click();
    })
   

    handleExportClose();
  };

  // Export to PDF
  const exportToPDF = () => {
    const doc = new jsPDF();
 
    // Title
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    // const title =
    //   board === "INTERMEDIATE"
    //     ? `${interSelectedClass}-${interSelectedSection} UnPaid School Fee List`
    //     : `${sscSelectedClass}-${sscSelectedSection} UnPaid School Fee List`;
    // doc.text(title, 10, 8);
     if (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection) {
  doc.text(`${interSelectedClass}-${interSelectedSection} UnPaid School Fee List`, 10, 8);
} else if (board === "SSC" && sscSelectedClass && sscSelectedSection) {
  doc.text(`${sscSelectedClass}-${sscSelectedSection} UnPaid School Fee List`, 10, 8);
} else {
  doc.text(`UnPaid School Fee List`, 10, 8);
}
 
    // Timestamp
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text("Generated On: ", 14, 16);
    doc.setFont("helvetica", "bold");
    doc.text(new Date().toLocaleDateString(), 40, 16);
 
    // Define table headers
    const headers =
      board === "INTERMEDIATE"
        ? [
            "S.No",
            "Admission No",
            "Course",
            "Year",
            "Section",
            "Student Name",
            "Father Name",
            "Phone",
            "Total Fee",
            "Due Amount",
          ]
        : [
            "S.No",
            "Admission No",
            "Class",
            "Section",
            "Student Name",
            "Father Name",
            "Phone",
            "Total Fee",
            "Due Amount",
          ];
 
    // Table body
    const bodyData = filteredResults.map((row, index) => {
      const rowData = [
        index + 1,
        row.customAdmissionNumber,
      ];
 
      if (board === "INTERMEDIATE") {
        rowData.push(row.course); // Add Course only for INTERMEDIATE
      }
 
      rowData.push(
        `${row.romanNumberClass}`,
        row.sections,
        `${row.firstName} ${row.lastName}`,
        row.fathersName,
        row.primaryContact,
        row.grandTotal,
        {
          content: row.feeDue,
          styles: { textColor: [255, 0, 0], fontStyle: "bold" }, // Red for Due
        }
      );
 
      return rowData;
    });
 
    // Render the table
    doc.autoTable({
      startY: 20,
      head: [headers],
      body: bodyData,
      styles: {
        lineWidth: 0.2,
        lineColor: "#B6B9CD",
      },
      headStyles: {
        fillColor: [63, 81, 181],
        textColor: [255, 255, 255],
        halign: "center",
      },
      bodyStyles: {
        halign: "center",
      },
      theme: "grid",
    });
 
    // File name
    // const fileName =
    //   board === "INTERMEDIATE"
    //     ? `${interSelectedClass}-${interSelectedSection}_UnPaidSchoolFeeList.pdf`
    //     : `${sscSelectedClass}-${sscSelectedSection}_UnPaidSchoolFeeList.pdf`;
 
    // doc.save(fileName);
     if (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection) {
  doc.save(`${interSelectedClass}-${interSelectedSection}_UnPaidSchoolFeeList.pdf`);
} else if (board === "SSC" && sscSelectedClass && sscSelectedSection) {
  doc.save(`${sscSelectedClass}-${sscSelectedSection}_UnPaidSchoolFeeList.pdf`);
} else {
  doc.save(`UnPaidSchoolFeeList.pdf`);
}
    handleExportClose();
  };
 

  // Export to JSON
  const exportToJSON = () => {
    const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
      JSON.stringify(filteredResults, null, 2)
    )}`;
    const link = document.createElement("a");
    link.href = jsonString;
    // if(board === "INTERMEDIATE") {
    //   link.download = `${interSelectedClass}-${interSelectedSection}_UnPaidSchoolFeeList.json`;
    // } else {
    //   link.download = `${sscSelectedClass}_${sscSelectedSection}_UnPaidSchoolFeeList.json`;
    // }
     if (
  board === "INTERMEDIATE" &&
  interSelectedClass &&
  interSelectedSection
) {
  link.download = `${interSelectedClass}-${interSelectedSection}_UnPaidSchoolFeeList.json`;
} else if (
  board === "SSC" &&
  sscSelectedClass &&
  sscSelectedSection
) {
  link.download = `${sscSelectedClass}_${sscSelectedSection}_UnPaidSchoolFeeList.json`;
} else {
  link.download = `UnPaidSchoolFeeList.json`;
}
    link.click();
    handleExportClose();
  };

  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
    <Card
      style={{
        // margin: "60px 20px",
        padding: "10px",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        width: "100%",
        // maxHeight: "100vh",
        // overflow: "hidden",
      }}
    >
      <CardContent>
        {/* Title Section */}
       
        <Box display="flex" alignItems="center" sx={{ marginBottom: 2 }}>
          <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
            <KeyboardBackspaceIcon fontSize="medium" />
          </IconButton>
          <Typography variant="h4" component="h3" sx={{ fontWeight: "bold" }}>
            {`${
              dateRangeFromQuery
                ? dateRangeFromQuery.charAt(0).toUpperCase() +
                  dateRangeFromQuery.slice(1)
                : ""
            }  UnPaid Tution Fee List`}
          </Typography>
        </Box>

        {/* Search and Add New Button Section */}
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          style={{ marginTop: "1px" }}
        >
          {/* Left Side - Search & Select */}
          <Grid
            item
            xs={9}
            style={{ display: "flex", gap: "5px", alignItems: "center" }}
          >
            <TextField
              label="Search by Admission No or Name"
              variant="outlined"
              size="small"
              style={{ width: "220px" }}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              fullWidth
            />

           

                             {/* {board === "SSC" && (
  <>
    <FormControl size="small" sx={{ minWidth: 120,marginRight:2}}>
      <InputLabel id="class-select-label">Select Class</InputLabel>
      <Select
        labelId="class-select-label"
        value={sscSelectedClass}
       

        onChange={(e) => {
          const selected = e.target.value;
          setSscSelectedClass(selected);
          setMode("classSection");
     
          const sections = sscClassSectionMap[selected] ? Array.from(sscClassSectionMap[selected]) : [];
          setSscSectionOptions(sections);
          setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0] || "");
        }}
       
        label="Select Class"
        sx={{ height: 35 }}
      >
        {sscClassOptions.map((cls) => (
          <MenuItem key={cls} value={cls}>{cls}</MenuItem>
        ))}
      </Select>
    </FormControl>
{/*
    <FormControl size="small" sx={{ minWidth: 120}}>
      <InputLabel id="section-select-label">Select Section</InputLabel>
      <Select
        labelId="section-select-label"
        value={sscSelectedSection}
        // onChange={(e) => setSscSelectedSection(e.target.value)}
        onChange={(e) => {
          setSscSelectedSection(e.target.value);
          setMode("classSection");
        }}
       
        label="Select Section"
        sx={{ height: 35 }}
        // disabled={sscSectionOptions.length === 0}
      >
       
        {sscSectionOptions.map((section) => (
          <MenuItem key={section} value={section}>{section}</MenuItem>
        ))}
      </Select>
    </FormControl>
    <FormControl size="small" sx={{ minWidth: 120 ,marginRight:2}}>
  <InputLabel id="section-select-label">Select Section</InputLabel>
  <Select
    labelId="section-select-label"
    value={sscSelectedSection}
    onChange={(e) => {
      setSscSelectedSection(e.target.value);
      setMode("classSection");
    }}
    label="Select Section"
    sx={{ height: 35 }}
  >
    {/* Show placeholder if no sections
    {sscSectionOptions.length === 0 ? (
      <MenuItem value="" disabled>
        Select Class
      </MenuItem>
    ) : (
      sscSectionOptions.map((section) => (
        <MenuItem key={section} value={section}>
          {section}
        </MenuItem>
      ))
    )}
  </Select>
</FormControl>

  </>
)} */}


{/* {board === "INTERMEDIATE" && (
  <>
    <FormControl size="small" sx={{ minWidth: 120}}>
      <InputLabel id="intermediate-class-select-label">Select Year</InputLabel>
      <Select
        labelId="intermediate-class-select-label"
        value={interSelectedClass}
        onChange={(e) => setInterSelectedClass(e.target.value)}
        label="Select Year"
        sx={{ height: 35 }}
      >
        <MenuItem value="Inter-1st-Year">Inter-1st-Year</MenuItem>
        <MenuItem value="Inter-2nd-Year">Inter-2nd-Year</MenuItem>
      </Select>
    </FormControl>

    <FormControl size="small" sx={{ minWidth: 120}}>
      <InputLabel id="course-type-label">Select Course</InputLabel>
      <Select
        labelId="course-type-label"
        value={selectedCourseType}
        // onChange={(e) => setSelectedCourseType(e.target.value)}
        onChange={(e) => {
          setSelectedCourseType(e.target.value);
          setMode("classSection");
        }}
       
        label="Select Course"
        sx={{ height: 35 }}
      >
        {courseOptions.map((course, index) => (
          <MenuItem key={index} value={course}>{course}</MenuItem>
        ))}
      </Select>
    </FormControl>

   
    <FormControl size="small" sx={{ minWidth: 120 }}>
  <InputLabel id="intermediate-section-select-label">Select Section</InputLabel>
  <Select
    labelId="intermediate-section-select-label"
    value={interSelectedSection || ""}
    onChange={(e) => {
      setInterSelectedSection(e.target.value);
      setMode("classSection");
    }}
    label="Select Section"
    sx={{ height: 35 }}
  >
    {interSectionOptions.length === 0 ? (
      <MenuItem value="" disabled>
        Select Year and Course
      </MenuItem>
    ) : (
      interSectionOptions.map((section, index) => (
        <MenuItem key={index} value={section}>
          {section}
        </MenuItem>
      ))
    )}
  </Select>
</FormControl>

  </>
)} */}

{/* <Button
  onClick={() => {
    if (board === "SSC") {
      setSscSelectedClass('');
      setSscSelectedSection('');
    } else if (board === "INTERMEDIATE") {
      setInterSelectedClass('');
      setSelectedCourseType('');
      setInterSelectedSection('');
    }

    setMode("scrolling");
    fetchGetAllTableData();
  }}
  variant="outlined"
  color="primary"
  sx={{marginLeft:'10px',width:'170px',height:'35px'}}
>
  Fetch OverAll Data
</Button> */}


 {isPrincipal && (
          <FormControl fullWidth style={{ width: "150px" ,marginLeft:'5px'}} size="small">
            <InputLabel>Select Admin</InputLabel>
            <Select
              value={selectedUsers}
              onChange={(e) => setSelectedUsers(e.target.value)}
              label="Select Admin"
            >
              {users.map((user) => (
                <MenuItem key={user.userId} value={user.userId}>
                  {user.userId}-{user.firstName} {user.lastName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

           
          </Grid>

          {/* Right Side - Button */}

          <Grid
            item
            xs={3}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              variant="contained"
              onClick={handleExportClick}
              style={{ backgroundColor: "#3C3972", fontWeight: "bold" }}
              startIcon={<PresentToAllIcon />}
            >
              Export
            </Button>

            <Menu
              anchorEl={exportAnchorEl}
              open={isExportMenuOpen}
              onClose={handleExportClose}
              sx={{
                "& .MuiPaper-root": {
                  backgroundColor: "#f5f5f5",
                  borderRadius: "8px",
                },
              }}
            >
              <MenuItem
                onClick={exportToExcel}
                sx={{
                  color: "#3f51b5",
                  fontWeight: "bold",
                  "&:hover": {
                    backgroundColor: "#e8f0fe",
                  },
                }}
              >
                <ListItemIcon sx={{ color: "#00796b" }}>
                  <SimCardDownloadIcon />
                </ListItemIcon>
                <ListItemText
                  primary="Excel"
                  sx={{ fontWeight: "bold", color: "#00796b" }}
                />
              </MenuItem>

              <MenuItem
                onClick={exportToPDF}
                sx={{
                  color: "#d32f2f",
                  fontWeight: "bold",
                  "&:hover": {
                    backgroundColor: "#fdecea",
                  },
                }}
              >
                <ListItemIcon sx={{ color: "#d32f2f" }}>
                  <PictureAsPdfIcon />
                </ListItemIcon>
                <ListItemText
                  primary="PDF"
                  sx={{ fontWeight: "bold", color: "#d32f2f" }}
                />
              </MenuItem>

              <MenuItem
                onClick={exportToJSON}
                sx={{
                  color: "#388e3c",
                  fontWeight: "bold",
                  "&:hover": {
                    backgroundColor: "#e8f5e9",
                  },
                }}
              >
                <ListItemIcon sx={{ color: "#6a1b9a" }}>
                  <FilePresentIcon />
                </ListItemIcon>
                <ListItemText
                  primary="JSON"
                  sx={{ fontWeight: "bold", color: "#6a1b9a" }}
                />
              </MenuItem>
            </Menu>
          </Grid>
        </Grid>

        <GlobalStyles
          styles={{
            ".custom-sidebar-scrollbar": {
              scrollbarWidth: "thin", // For Firefox
              scrollbarColor: "grey #e0e0e0",
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar": {
              width: "6px", // For WebKit-based browsers
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
              background: "#f1f1f1", // Track color
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
              backgroundColor: "grey", // Thumb color
              borderRadius: "10px",
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
          }}
        />

        {/* Table Section */}
        <TableContainer
          component={Paper}
          style={{
            marginTop: "20px",
            borderRadius: "8px",
            maxHeight: "800px",
            overflow: "auto",
          }}
          className="custom-sidebar-scrollbar"
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  S.No
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Admission No
                </TableCell>
                {(board === "INTERMEDIATE" ) && (
                                                    <TableCell
                                                      sx={{
                                                        borderRight: "1px solid #ddd",
                                                        padding: "4px",
                                                        backgroundColor: "#fff9c4",
                                                        textAlign: "center",
                                                        fontWeight: "Bold",
                                                      }}
                                                    >
                                                      Course
                                                    </TableCell>
                                                    )}
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  {board === "INTERMEDIATE" ? "Year" : "Class"}
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Section
                </TableCell>

                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Name
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Gender
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "2px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Father Name
                </TableCell>

                <TableCell
                  sx={{
                    borderRight: "2px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Phone
                </TableCell>

                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  UnPaid Amount
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Payment Details{" "}
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {!hasFetchedOnce || loading  ? (
             
                <TableRow>
                  <TableCell
                    colSpan={12}
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                    >
                      <CircularProgress />
                      <Typography variant="body2" sx={{ mt: 1 }}>
                        Loading Data...
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ) : filteredResults.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={12} style={{ textAlign: "center" }}>
                    No data found.
                  </TableCell>
                </TableRow>
              ) : (
                filteredResults.map((row, index) => (
                  <TableRow
                    key={row.id}
                    style={{
                      backgroundColor: "white",
                      transition: "background-color 0.3s",
                      height: "30px", // Reduced row height
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "white"; // Default color
                    }}
                  >
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {index + 1}
                    </TableCell>

                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.customAdmissionNumber}
                    </TableCell>
                   {board === "INTERMEDIATE" && (
                                                               <TableCell
                                                                 sx={{
                                                                   borderRight: "1px solid #ddd",
                                                                   padding: "4px",
                                                                   textAlign: "center",
                                                                 }}
                                                               >
                                                                 {row.course}
                                                               </TableCell>
                                                               )}
                    <TableCell
                      sx={{
                        borderRight: "1px solid #ddd",
                        padding: "3px",
                        textAlign: "center",
                      }}
                    >
                      {["NURSERY", "LKG", "UKG"].includes(
                        row.romanNumberClass?.toString().trim()
                      )
                        ? row.romanNumberClass
                        : `${row.romanNumberClass}`}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.sections}
                    </TableCell>

                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.firstName} {row.lastName}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.gender || "N/A"}
                    </TableCell>

                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.fathersName}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.primaryContact}
                    </TableCell>

                    <TableCell
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        style={{
                          backgroundColor: "#ED3638",
                          color: "#fff",
                          fontWeight: "bold",
                          textTransform: "none",
                          borderRadius: "20px",
                        }}
                      >
                        ₹{row.feeDue}
                      </Button>
                    </TableCell>
                    <TableCell
                      sx={{
                        borderLeft: "1px solid #ddd",
                        padding: "4px",
                        textAlign: "center",
                      }}
                    >
                      <Button
                        type="button"
                        onClick={() => handleViewClick(row)} // Open dialog with the row data
                        sx={{
                          backgroundColor: "#1976d2",
                          color: "white",
                          fontSize: "0.6rem", // Reduces the font size
                          height: "25px", // Reduces the height
                          "&:hover": {
                            backgroundColor: "#1565c0",
                          },
                        }}
                      >
                        View
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog
          open={dialogOpen}
          onClose={handleCloseDialog}
          fullWidth
          maxWidth="sm"
          sx={{ borderRadius: 3 }}
        >
          <DialogTitle
            sx={{
              fontWeight: "bold",
              textAlign: "center",
              bgcolor: "#1976d2",
              color: "white",
              py: 2,
              borderTopLeftRadius: 3,
              borderTopRightRadius: 3,
            }}
          >
            UnPaid Fee Payment Details
          </DialogTitle>
          <DialogContent>
            {selectedRowData && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  marginTop: "20px",
                  gap: 2,
                  p: "20px 20px 20px 20px",
                  bgcolor: "#f5f5f5",
                  borderRadius: 2,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontWeight: "bold",
                    color: "#333",
                  }}
                >
                  Student Name:
                  <span
                    style={{
                      fontWeight: "normal",
                      color: "#2e7d32",
                      fontWeight: "bold",
                    }}
                  >
                    {selectedRowData.surName} {selectedRowData.firstName}{" "}
                    {selectedRowData.lastName}
                  </span>
                </Typography>

                <Typography
                  variant="h6"
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontWeight: "bold",
                    color: "#333",
                  }}
                >
                  Total Amount:
                  <span
                    style={{
                      fontWeight: "normal",
                      color: "#2e7d32",
                      fontWeight: "bold",
                    }}
                  >
                    ₹{selectedRowData.grandTotal}
                  </span>
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontWeight: "bold",
                    color: "#333",
                  }}
                >
                   {`${
              dateRangeFromQuery
                ? dateRangeFromQuery.charAt(0).toUpperCase() +
                  dateRangeFromQuery.slice(1)
                : ""
            } Paid Amount:`}
                  <span
                    style={{
                      fontWeight: "normal",
                      color: "#2e7d32",
                      fontWeight: "bold",
                    }}
                  >
                    ₹{selectedRowData.totalPaid}
                  </span>
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontWeight: "bold",
                    color: "#333",
                  }}
                >
                 
                  Due Amount:
                  <span
                    style={{
                      fontWeight: "normal",
                      color: "#ED3638",
                      fontWeight: "bold",
                    }}
                  >
                    ₹{selectedRowData.feeDue}
                  </span>
                </Typography>
                {/* <Typography
                  variant="h6"
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontWeight: "bold",
                    color: "#333",
                  }}
                >
                  Status:
                  <span
                    style={{
                      fontWeight: "normal",
                      color: "#ED3638",
                      fontWeight: "bold",
                    }}
                  >
                    School Fees Not Cleared
                  </span>
                </Typography> */}

                {/* Transactions Toggle Section */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    cursor: "pointer",
                    fontWeight: "bold",
                    color: "#1976d2",
                    "&:hover": { textDecoration: "underline" },
                  }}
                  onClick={() => setShowTransactions(!showTransactions)}
                >
                  <Typography variant="h6"> Show Transactions</Typography>
                  <Typography variant="h6">
                    {showTransactions ? "▲" : "▼"}
                  </Typography>
                </Box>

                {/* Transaction Table - Conditional Rendering */}
                {showTransactions && (
                  <TableContainer
                    component={Paper}
                    sx={{ mt: 2, maxHeight: "140px", overflowY: "auto" }}
                    className="custom-sidebar-scrollbar"
                  >
                    <Table stickyHeader>
                      <TableHead sx={{ bgcolor: "#1976d2" }}>
                        <TableRow>
                          <TableCell
                            sx={{
                              borderRight: "1px solid #ddd",
                              padding: "2px",
                              textAlign: "center",
                              backgroundColor: "#fff9c4",
                            }}
                          >
                            Sl No
                          </TableCell>
                          <TableCell
                            sx={{
                              borderRight: "1px solid #ddd",
                              padding: "2px",
                              textAlign: "center",
                              backgroundColor: "#fff9c4",
                            }}
                          >
                            Payment Date
                          </TableCell>
                          <TableCell
                            sx={{
                              borderRight: "1px solid #ddd",
                              padding: "2px",
                              textAlign: "center",
                              backgroundColor: "#fff9c4",
                            }}
                          >
                            Amount Paid
                          </TableCell>
                          <TableCell
                            sx={{
                              borderRight: "1px solid #ddd",
                              padding: "2px",
                              textAlign: "center",
                              backgroundColor: "#fff9c4",
                            }}
                          >
                            Transaction ID
                          </TableCell>
                          <TableCell
                            sx={{
                              borderRight: "1px solid #ddd",
                              padding: "2px",
                              textAlign: "center",
                              backgroundColor: "#fff9c4",
                            }}
                          >
                            Payment Type
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {dialogTableloading ? (
                          <TableRow>
                            <TableCell
                              colSpan={12}
                              style={{ textAlign: "center", padding: "20px" }}
                            >
                              <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                              >
                                <CircularProgress />
                                <Typography variant="body2" sx={{ mt: 1 }}>
                                  Loading Data...
                                </Typography>
                              </Box>
                            </TableCell>
                          </TableRow>
                        ) : dialogTableData.length === 0 ? (
                          <TableRow>
                            <TableCell
                              colSpan={12}
                              style={{ textAlign: "center" }}
                            >
                              No data found.
                            </TableCell>
                          </TableRow>
                        ) : (
                          dialogTableData.map((transaction, index) => (
                            <TableRow key={transaction.transactionId}>
                              <TableCell
                                sx={{
                                  textAlign: "center",
                                  borderRight: "1px solid #ddd",
                                  padding: "2px",
                                }}
                              >
                                {index + 1}
                              </TableCell>
                              <TableCell
                                sx={{
                                  textAlign: "center",
                                  borderRight: "1px solid #ddd",
                                  padding: "2px",
                                }}
                              >
                                {transaction.paymentDate}
                              </TableCell>
                              <TableCell
                                sx={{
                                  textAlign: "center",
                                  borderRight: "1px solid #ddd",
                                  padding: "2px",
                                }}
                              >
                                ₹{transaction.paymentAmount}
                              </TableCell>
                              <TableCell
                                sx={{
                                  textAlign: "center",
                                  borderRight: "1px solid #ddd",
                                  padding: "2px",
                                }}
                              >
                                {transaction.transactionId || "N/A"}
                              </TableCell>
                              <TableCell
                                sx={{
                                  textAlign: "center",
                                  borderRight: "1px solid #ddd",
                                  padding: "2px",
                                }}
                              >
                                {transaction.payMethod}
                              </TableCell>
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </Box>
            )}
          </DialogContent>
          <DialogActions
            sx={{ justifyContent: "flex-end", pt: 0.5, pb: 1, pr: 2 }}
          >
            <Button
              onClick={handleCloseDialog}
              variant="contained"
              sx={{
                fontSize: "0.8rem", // Slightly smaller font size
                // px: 3,
                // py: 0.5, // Reduced height
                // borderRadius: 2,
                bgcolor: "#3C3972", // Elegant blue color
                color: "white",
                "&:hover": { bgcolor: "#3C3972" },
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </CardContent>
    </Card>
    </Box>
  );
}

export default OrgDashUnPaidTutionFee;